// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { GRUPO_FIELDS_FRAGMENT } from '../interfaces/fragmentGr'
import {
  GrupoUnidadMedidaInputProps,
  GrupoUnidadMedidaProps,
} from '../../../interfaces/grupoUnidadMedida.ts'

// Definimos la mutación GraphQL
const MUTATION_ACTUALIZAR_GRUPO = gql`
  ${GRUPO_FIELDS_FRAGMENT}
  mutation ACTUALIZAR_GRUPO_UNIDAD_MEDIDA($id: ID!, $input: GrupoUnidadMedidaInput!) {
    grupoUnidadMedidaActualizar(id: $id, input: $input) {
      ...GrupoField
    }
  }
`

// Función para actualizar el grupo de unidad de medida
export const apiGrupoUnidadMedidaActualizar = async (
  id: string,
  input: GrupoUnidadMedidaInputProps,
): Promise<GrupoUnidadMedidaProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(MUTATION_ACTUALIZAR_GRUPO, { id, input })
    console.log('Respuesta de la API:', data)
    return data.apiGrupoUnidadMedidaActualizar
  } catch (error: any) {
    throw new MyGraphQlError(error)
  }
}
